import {XauditModel} from '../xaudit.model';
import {NotificationDataModel} from './notification-data.model';
import {NotificationConversationDataModel} from './notification-conversation-data.model';

export class NotificationDestinationDataModel extends XauditModel {
  NotificationToID: string;
  NotificationID: string;
  WorkStationId: string;
  UserID: string;
  enumNotificationStatusID: string;
  ConversationID: string;

  dataNotification: NotificationDataModel;
  dataNotificationConversation: NotificationConversationDataModel;
}
